import _forEach from 'lodash-es/forEach';
import _concat from 'lodash-es/concat';

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { GenericFieldset, IGenericFieldset } from '../generic-fieldset.component';

/**
 * Quantity-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({

    selector: 'carrier-fieldset',
    templateUrl: './carrier-fieldset.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarrierFieldsetComponent extends GenericFieldset implements IGenericFieldset {
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'carrier';

    /** DI - Formbuilder */
    constructor (public fb: FormBuilder) {
        super(fb);
    }

    public getValue( _fields: Array<string> ): any{

        const fieldset = this.group;
        let tempArray: Array<string> = [];

        _forEach( _fields , ( _fieldName: string ) =>{
            const field = fieldset.get( _fieldName );
            if( field ){
                tempArray = _concat( tempArray, field.value );
            }
        });

        return tempArray;
    }
}